export default class ChieuDaiNguonNuoc {
    constructor() {

    }
}